/*
 * @Description: 产品中心骨架屏
 * @Author: liuzhezhe
 * @Date: 2023-06-29 13:38:47
 * @LastEditors: 陈威达
 * @LastEditTime: 2023-07-06 19:19:52
 */
import React, { useState, useEffect } from 'react'
import styles from './index.scss'

const OrderSkeletons = (props) => {
  const index = props.index
  console.log(index)
  const [state] = useState([1, 2, 3, 4, 5, 6])

  useEffect(() => {
  }, [])

  return (
    <div className={styles['order-skeletons']}>
      {state.map(item => (
        <div className={styles['order-item']} key={item}>
          <div className={styles['skeletons']}></div>
          <div className={styles['skeletons']}></div>
          <div className={styles['skeletons']}></div>
        </div>
      ))}
    </div>
  )
}

export default OrderSkeletons
